/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type DayOfWeek = (typeof DayOfWeek)[keyof typeof DayOfWeek];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DayOfWeek = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
} as const;
